import React from 'react';
import './Form.css';
import { v4 as uuidv4 } from 'uuid';

export default function Form(props) {
    
    const sendTask = (e) => {
        e.preventDefault();
        if (props.inputValue.trim()) {
            const newTask = {
                id: uuidv4(),
                text: props.inputValue,
                completed: false
            };
            props.onSubmit(newTask);
            e.target.reset();
        }
    };

    return (
        <form className="task-form" onSubmit={sendTask}>
            <input
                type="text"
                className="task-input"
                placeholder='Agrega tarea'
                name='text'
                autocomplete="off"
                value={props.inputValue}
                onChange={props.onInputChange}
            />

            <button className="task-button">
                Add
            </button>
        </form>
    );
}
